import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import useUser from '../../../../contexts/hooks/useUser'
import { trpc } from '../../../../modules/trpc'
import PageWrapper from '../../../../wrappers/pageWrapper/PageWrapper'
import MaxPower from '../solarPanelSettings/SolarPanelSettings'

const SolarPanelSetup: React.FC = () => {
	const { user, setUser } = useUser()
	const history = useHistory()
	const utils = trpc.useContext()

	const { data: inverters } = trpc.eNode.inverter.getAll.useQuery(
		{ hashedPid: user?.hashedPid ?? '' },
		{ enabled: Boolean(user?.hashedPid) }
	)

	const { mutate: createLocation } = trpc.eNode.locations.createLocation.useMutation()

	useEffect(() => {
		if (!user) return
		setUser({ panelLinked: true })
		utils.eNode.invalidate()
		utils.objects.getEnergyReport.invalidate()
	}, [])

	useEffect(() => {
		if (!user || !inverters) return
		inverters
			.filter(inverter => !inverter.chargingLocationId)
			.forEach(inverter => {
				if (!inverter.location.latitude || !inverter.location.longitude) return
				createLocation({
					hashedPid: user.hashedPid,
					latitude: inverter.location.latitude,
					longitude: inverter.location.longitude,
					name: 'inverter home',
					timezoneName: 'Europe/Helsinki',
				})
			})
	}, [inverters?.length])

	return (
		<PageWrapper page='addSolarPanel'>
			<MaxPower onClose={() => history.push('/devices/add-device')} />
		</PageWrapper>
	)
}

export default SolarPanelSetup
